// 引入axios
import axios from "axios";
import { message } from "antd";

// const BASE_ENV = process.env.BASE_ENV;
// const baseURL = `//${
//   BASE_ENV === 'prod' || BASE_ENV === 'prev' ? '' : BASE_ENV + '-'
// }api.k7.cn/`
// const baseURL = `http://192.168.111.253:8188/hatu/`;
const baseURL = `https://apip.ihatoo.com/hatu/`;
// console.log(BASE_ENV);

// 创建axios实例
const service = axios.create({
  baseURL, // api的base_url  Vue项目可以根据 process.env.BASE_API，React可以在这里定义
  timeout: 20 * 1000, // 请求超时时间
  // withCredentials: false, // 跨域携带cookie
});

// 添加请求拦截器，这里面可以配置一下每次请求都需要携带的参数，比如 token，timestamp等等，根据项目自己配置
service.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["Access-Control-Allow-Origin"] = "*";

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    // console.log(error); // for debug
    return Promise.reject(error);
  }
);

// 添加响应拦截器 ，这里的 response是接收服务器返回后的结果，也可以在这里做一些状态判断
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      switch (res.code) {
        default:
          message.error(res.msg || "Error", 2);
          break;
      }
      // return Promise.reject(new Error(res.msg || "Error"));
      return res.code;
    } else {
      return res;
    }
  },
  (error) => {
    message.info(error.message, 2);
    return Promise.reject(error);
  }
);
// 提供axios给外部调用
export default service;
